import React from 'react';
import SignatureRequestsList from '../components/cases/SignatureRequestsList';

const SignatureRequestsPage = () => {
  return (
    <div className="min-h-screen bg-virgo-navy-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <SignatureRequestsList />
      </div>
    </div>
  );
};

export default SignatureRequestsPage;
